import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import * as logging from 'util/Logging';

dayjs.extend(utc);

export const DATA_TEST_TIMESTAMP = 'data-test-timestamp';

export default function getTestTimestampProps(dateString: string): DataTestTimestampProps {
  let formattedDateString = '';

  try {
    formattedDateString = dayjs(dateString).toISOString();
  } catch (e) {
    logging.error(`An error occurred while parsing a datestring with dayjs: ${e.message}`);
  }

  return {[DATA_TEST_TIMESTAMP]: formattedDateString};
}

export interface DataTestTimestampProps {
  [DATA_TEST_TIMESTAMP]: string;
}
